import { ArpMedia, ArpMediaType } from '@arpeggi/shared'
import { useRemix } from '../../__legacy__/components/platform/explore/common/utils'
import { IArpMedia } from '../arp-registry/ArpMedia'

export const useRemixArpMedia = (media: ArpMedia | IArpMedia) => {
  const { status, remixSong, remixSample, remixStem } = useRemix()
  const { type, id } = media
  const remix = () => {
    if (type === ArpMediaType.SAMPLE) remixSample(id)
    if (type === ArpMediaType.SONG) remixSong(id)
    if (type === ArpMediaType.STEM) remixStem(id)
  }
  return { status, remix }
}
